import styled from 'styled-components';

export const BannerContainer = styled.div`
  background: #fff url(${(props) => props.$backgroundImageUrl}) no-repeat top
    center;
  @media (max-width: 991px) {
    background: #fff url(${(props) => props.$backgroundImageTabletUrl})
      no-repeat top center;
    background-size: auto 500px;
  }
  @media print {
    display: none !important;
  }
`;
export const BannerInnerContainer = styled.div`
  margin: auto;
  height: 514px;
  margin-top: -116px;
  width: 1200px !important;
  @media (max-width: 1200px) {
    max-width: 960px !important;
  }
  @media (max-width: 991px) {
    margin-top: -170px;
    height: 500px;
    max-width: 728px !important;
  }
`;
